const isNonNullish = (input) => {
  return input != null;
};
const richText = (field) => {
  if (!isNonNullish(field)) {
    return false;
  } else if (field.length === 1 && "text" in field[0]) {
    return !!field[0].text;
  } else {
    return !!field.length;
  }
};
const imageThumbnail = (thumbnail) => {
  return isNonNullish(thumbnail) && !!thumbnail.url;
};
const link = (field) => {
  return isNonNullish(field) && ("id" in field || "url" in field);
};
export {
  imageThumbnail,
  link,
  richText
};
//# sourceMappingURL=isFilled.js.map
